import { InvoiceTransModel } from "./invoice-trans.model";

export class PetInvoiceListModel {
    pet_no: number;
    pet_name: string;
    Procs: InvoiceTransModel[];
    Notes: any; // Update with the actual type
    Alerts: any; // Update with the actual type
    Rabies:number;
    Neuter:number;
    PetBal: number;
    PetDeposit: number;

    constructor(
        pet_no: number,
        pet_name: string,
        Procs: InvoiceTransModel[],
        Notes: any, // Update with the actual type
        Alerts: any,// Update with the actual type
        Rabies:number,
        Neuter:number,
        PetBal: number,
        PetDeposit: number,
    )
    {
        this.pet_no = pet_no
        this.pet_name = pet_name
        this.Procs = Procs
        this.Notes = Notes
        this.Alerts = Alerts
        this.Rabies = Rabies
        this.Neuter = Neuter
        this.PetBal = PetBal
        this.PetDeposit = PetDeposit
    }
  }
  
  // procedure.model.ts
  export class Inv_ProcedureModel {
    code_name: string;
    item_desc: string;
    link_no: number;
    link_type: number;
    status: string;
    cost: number;
    done_date: string;
    req_date: string;
    location: string;
    response1: string;
    response2: string;

    constructor(
        code_name: string,
        item_desc: string,
        link_no: number,
        link_type: number,
        status: string,
        cost: number,
        done_date: string,
        req_date: string,
        location: string,
        response1: string,
        response2: string,
    )
    {
        this.code_name = code_name
        this.item_desc = item_desc
        this.link_no = link_no
        this.link_type = link_type
        this.status = status
        this.cost = cost
        this.done_date = done_date
        this.req_date = req_date
         = location
        this.response1 = response1
        this.response2 = response2
    }
  }
  